export default __webpack_public_path__ + "static/media/icon-5G-simple.4dc5b907.svg";